import React from "react";
import HomeMainSection from "../components/HomeMainSection";
import HomeWorldBusinessNews from "../components/HomeWorldBusinessNews";
import HomeLastWeekSection from "../components/HomeLastWeekSection";
import HomeLastMonthSection from "../components/HomeLastMonthSection";

const Home = () => {

    return (
        <>
            <HomeMainSection />
            <HomeWorldBusinessNews />
            {/* <div className="container space-top">
                <a href="https://themeforest.net/user/themeholy/portfolio">
                    <img
                        src="/assets/img/ads/ads_1.jpg"
                        alt="ads"
                        className="w-100"
                    />
                </a>
            </div> */}
            <HomeLastWeekSection />
            <HomeLastMonthSection />
            <div className="bg-smoke py-lg-4 w-100">
                <div className="container">
                    <div className="row flex-row-reverse justify-content-center justify-content-lg-between align-items-center">
                        <div className="col-lg-5 mb-n3 mb-lg-0">
                            <div className="text-center text-lg-end pt-4 pt-lg-0">
                                <img
                                    src="/assets/img/bg/newsletter_img.png"
                                    alt="icon"
                                />
                            </div>
                        </div>
                        <div className="col-lg-7 py-4 text-center text-lg-start">
                            <h2 className="box-title-30 mb-30">
                                Join Our Newsletter to receive <br /> Daily
                                Update News
                            </h2>
                            <form className="newsletter-form width2">
                                <input
                                    className="form-control"
                                    type="email"
                                    placeholder="Enter Email"
                                    required=""
                                />
                                <button type="submit" className="th-btn">
                                    Subscribe
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;
